import React from "react";
import AscComponent from "../../components/AscComponent";
import { Row, Col, Button } from "react-bootstrap";
import InlineForm from "../Elements/FromGroup/InlineForm";
import DatePicker from "react-datepicker";
import Select from "react-select";
import * as GlobalConst from "../../components/AscConstants";
import CallType from "../Script/Template/CallType";
import IvrHistoryScriptDetail from "./IvrHistoryScriptDetail";

export default class IvrHistoryMenu extends AscComponent {
    constructor(props) {
        super(props);
    }

    getSearchBtn = () => {
        let {
            state,
            onSearch,
            langText,
        } = this.props;

        return (
            <Button
                className="ok-execute-btn button-size"
                bsStyle="info"
                onClick={e => onSearch(state.filtered)}
                disabled={state.loading || state.searchValidation}
            >
                {langText.Body.Search}
            </Button>
        );
    }

    getClearBtn = () => {
        let {
            onClear,
            langText
        } = this.props;

        return (
            <Button
                className="default-button button-size clear-button"
                onClick={e => onClear()}>
                {langText.Body.Clear}
            </Button>
        );
    }

    getHeaderConditionInfo = () => {
        let {
            state,
            langText,
            getFilterData,
            getScopeGreaterEqual,
            onChange,
        } = this.props;

        let itemArr = [];

        // エラーメッセージ
        if (state.message) {
            itemArr.push(
                <Col sm={12} md={12}>
                    <label className="search-message">{state.message}</label>
                </Col>
            );
        }

        // OEM以上は会社選択表示、会社管理者未満は会社名を静的表示
        if (getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.oem)) {
            itemArr.push(
                <InlineForm
                    key="company_id"
                    controlId="company_id"
                    className="padding-bottom-05"
                    label={langText.Body.CompanyName}
                    type="select"
                    onChange={e => onChange(e, "cm12_id")}
                    options={state.companySelect}
                    value={getFilterData("cm12_id") ? getFilterData("cm12_id").value : ""}
                    placeholder={langText.SelectOption.Placeholder}
                />
            );
        } else {
            itemArr.push(
                <InlineForm.static
                    key="company_id"
                    controlId="company_id"
                    label={langText.Body.CompanyName}>
                    {this.props.userInfo ? this.props.userInfo.company_name : ""}
                </InlineForm.static>
            );
        }

        return itemArr;
    }

    getConditionInfo = () => {
        let {
            state,
            langText,
            getFilterData,
            getScopeGreaterEqual,
            onChange,
            hourShowList,
            minuteShowList,
            operatorArr,
        } = this.props;

        let itemArr = [];

        // 開始日
        itemArr.push(
            <InlineForm
                key="StartDatetime"
                controlId="StartDatetime"
                label={langText.Body.StartDate}
            >
                <Col className="padding-bottom-05">
                    <Col sm={12} md={6} lg={6} className="padding-left-0 padding-right-0">
                        <DatePicker
                            onChange={e => onChange(e, "start_datetime")}
                            selected={getFilterData("start_datetime") ? getFilterData("start_datetime") : null}
                            dateFormat="YYYY-MM-DD"
                            className="form-control"
                            todayButton={langText.Body.Today}
                            placeholderText={langText.Body.StartDate}
                            maxDate={getFilterData("end_datetime") ? getFilterData("end_datetime") : null}
                        />
                    </Col>
                    <Col sm={12} md={3} lg={3} className="padding-right-0">
                        <Select
                            key="start_ji"
                            value={getFilterData("start_ji")}
                            onChange={e => onChange(e, "start_ji")}
                            options={hourShowList}
                            isDisabled={!state.filtered.some(row => row.id === "start_datetime")}
                            placeholder="---"
                        />
                    </Col>
                    <Col sm={12} md={3} lg={3} className="padding-right-0 padding-bottom-05">
                        <Select
                            key="start_hun"
                            value={getFilterData("start_hun")}
                            onChange={e => onChange(e, "start_hun")}
                            options={minuteShowList}
                            isDisabled={!state.filtered.some(row => row.id === "start_datetime")}
                            placeholder="---"
                        />
                    </Col>
                </Col>
            </InlineForm>
        );

        // 終了日
        itemArr.push(
            <InlineForm
                key="EndDatetime"
                controlId="EndDatetime"
                label={langText.Body.EndDate}
            >
                <Col className="padding-bottom-05">
                    <Col sm={12} md={6} lg={6} className="padding-left-0 padding-right-0">
                        <DatePicker
                            onChange={e => onChange(e, "end_datetime")}
                            selected={getFilterData("end_datetime") ? getFilterData("end_datetime") : null}
                            dateFormat="YYYY-MM-DD"
                            className="form-control"
                            todayButton={langText.Body.Today}
                            placeholderText={langText.Body.EndDate}
                            minDate={getFilterData("start_datetime") ? getFilterData("start_datetime") : null}
                        />
                    </Col>
                    <Col sm={12} md={3} lg={3} className="padding-right-0">
                        <Select
                            key="end_ji"
                            value={getFilterData("end_ji")}
                            onChange={e => onChange(e, "end_ji")}
                            options={hourShowList}
                            isDisabled={!state.filtered.some(row => row.id === "end_datetime")}
                            placeholder="---"
                        />
                    </Col>
                    <Col sm={12} md={3} lg={3} className="padding-right-0 padding-bottom-05">
                        <Select
                            key="end_hun"
                            value={getFilterData("end_hun")}
                            onChange={e => onChange(e, "end_hun")}
                            options={minuteShowList}
                            isDisabled={!state.filtered.some(row => row.id === "end_datetime")}
                            placeholder="---"
                        />
                    </Col>
                </Col>
            </InlineForm>
        );

        // 外線番号
        itemArr.push(
            <InlineForm
                key="ExternalNumberForm"
                controlId="ExternalNumberForm"
                label={langText.Body.ExternalNumber}
            >
                <Col className="summary-period padding-bottom-35">
                    <InlineForm
                        key="ExternalNumber"
                        controlId="ExternalNumber"
                        type="select"
                        value={state.display_number && state.display_number.map(row => row.value)}
                        onChange={e => onChange(e, "display_number")}
                        options={state.externalArr}
                        isMulti={true}
                        closeMenuOnSelect={false}
                        placeholder={langText.SelectOption.Placeholder_All_Select}
                        colWidth={12}
                    />
                </Col>
            </InlineForm>
        );

        // 内線番号
        itemArr.push(
            <InlineForm
                key="ExtensionNumberForm"
                controlId="ExtensionNumberForm"
                label={langText.Body.ExtensionNumber}
            >
                <Col className="summary-period padding-bottom-35">
                    <InlineForm
                        key="ExtensionNumber"
                        controlId="ExtensionNumber"
                        type="select"
                        value={state.extension_number && state.extension_number.map(row => row.value)}
                        onChange={e => onChange(e, "extension_number")}
                        options={state.extensionNumberSelect}
                        isMulti={true}
                        closeMenuOnSelect={false}
                        placeholder={langText.SelectOption.Placeholder_All_Select}
                        colWidth={12}
                    />
                </Col>
            </InlineForm>
        );

        // オペレーター名
        if (state.showOperatorName) {
            itemArr.push(
                <InlineForm
                    key="OperatorNameForm"
                    controlId="OperatorNameForm"
                    label={langText.Body.OperatorName}
                >
                    <Col className="summary-period padding-bottom-35">
                        <InlineForm
                            key="OperatorName"
                            controlId="OperatorName"
                            type="select"
                            value={state.operator_name && state.operator_name.map(row => row.value)}
                            onChange={e => onChange(e, "operator_name")}
                            options={operatorArr || []}
                            isMulti={true}
                            closeMenuOnSelect={false}
                            placeholder={langText.SelectOption.Placeholder_All_Select}
                            colWidth={12}
                        />
                    </Col>
                </InlineForm>
            );
        }

        // 通話結果
        itemArr.push(
            <InlineForm
                key="ResultForm"
                controlId="ResultForm"
                label={langText.Body.CallHistory}
            >
                <Col className="summary-period padding-bottom-35">
                    <InlineForm
                        key="Result"
                        controlId="Result"
                        type="select"
                        value={state.disposition && state.disposition.map(row => row.value)}
                        onChange={e => onChange(e, "disposition")}
                        options={state.dispositionSelect}
                        isMulti={true}
                        closeMenuOnSelect={false}
                        placeholder={langText.SelectOption.Placeholder_All_Select}
                        colWidth={12}
                    />
                </Col>
            </InlineForm>
        );

        // 相手先番号（テキスト手動入力）
        itemArr.push(
            <Col key="dest_tel_no" sm={12} md={12} className="padding-left-0 padding-right-0 padding-bottom-05">
                <InlineForm
                    key="DestUserNumber"
                    controlId="DestUserNumber"
                    label={langText.Body.DestUserNumber}
                    onChange={e => onChange(e, "dest_tel_no")}
                    value={getFilterData("dest_tel_no")}
                />
            </Col>
        );

        // スクリプト（複数選択）
        itemArr.push(
            <InlineForm
                key="ScriptNameForm"
                controlId="ScriptNameForm"
                label={langText.Body.ScriptName}
            >
                <Col className="summary-period padding-bottom-35">
                    <InlineForm
                        key="ScriptName"
                        controlId="ScriptName"
                        type="select"
                        value={state.script_name && state.script_name.map(row => row.value)}
                        onChange={e => onChange(e, "script_name")}
                        options={state.scriptSelect}
                        isMulti={true}
                        closeMenuOnSelect={false}
                        placeholder={langText.SelectOption.Placeholder_All_Select}
                        colWidth={12}
                    />
                </Col>
            </InlineForm>
        );

        return itemArr;
    }


    render() {
        return (
            <Row className="menu-row">
                <Col className="title-col col-style" xs={12} sm={12}>
                    <div className="margin-left-05 margin-top-05">
                        {this.getClearBtn()}
                        {this.getSearchBtn()}
                    </div>
                    <div>
                        {this.getHeaderConditionInfo()}
                        <hr className="menu-hr" />
                    </div>
                </Col>
                <Col className="col-style padding-top-0" xs={12} sm={12}>
                    {this.getConditionInfo()}
                    <IvrHistoryScriptDetail
                        state={this.props.state}
                        langText={this.props.langText}
                        getFilterData={this.props.getFilterData}
                        onChange={this.props.onChange}
                        onToggleScriptDetail={this.props.onToggleScriptDetail}
                        enabledBlocks={this.props.enabledBlocks}
                        getBlockTypeLabel={this.props.getBlockTypeLabel}
                    />
                </Col>
            </Row>
        );
    }
}
